import { useMemo } from 'react'

import type { FeedItem } from '@/features/profiles/types/feed'
import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'

export const useFeedStore = () => {
  const {
    records: feedRaw,
    isEmpty,
    isSuccess
  } = useOptimizedRecords<FeedItem>({
    path: '/user/feed',
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: 180000
  })

  const feed = useMemo(() => {
    return feedRaw
  }, [feedRaw])

  return { feed, isEmpty, isSuccess }
}
